import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

export default function EmptyState({ onClearFilters }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-4 text-center">
      <div className="w-20 h-20 rounded-full flex items-center justify-center mb-5" style={{ background: 'rgba(201,160,32,0.1)' }}>
        <Icon name="SearchX" size={36} color="var(--color-accent)" strokeWidth={1.5} />
      </div>
      <h3 className="font-heading font-semibold text-xl mb-2" style={{ color: 'var(--color-foreground)' }}>No Opportunities Found</h3>
      <p className="font-caption text-sm max-w-sm mb-6" style={{ color: 'var(--color-muted-foreground)', fontFamily: 'var(--font-caption)' }}>
        No investment opportunities match your current filters. Try adjusting your criteria to discover more options.
      </p>
      <Button variant="default" onClick={onClearFilters} iconName="RefreshCw" iconPosition="left">
        Clear All Filters
      </Button>
    </div>
  );
}